import classNames from 'classnames';
import styles from './LinkButton.module.scss';
import { Icon } from '../..';
import ChevronRight from 'ui/icons/DEF_Chevron-right.svg';

export interface LinkButtonProps {
	children: React.ReactNode;
	state?: 'inactive';
	style?: 'primary' | 'secondary' | 'inactive' | 'sm' | 'tertiary' | 'blue' | 'negative' | 'linkBoxPrimary' | 'linkBoxSecondary';
	icon?: 'chevronRight';
	title?: string;
	className?: string;
	url?: string;
	onClick?: () => void;
	download?: boolean;
	target?: string;
	ref?: React.Ref<HTMLAnchorElement>;
}

export const LinkButton: React.FC<LinkButtonProps> = ({ children, style, title, className, state, url, onClick, download, target, ref, icon }) => (
	<a
		href={url}
		title={title}
		className={classNames(styles.LinkButton, styles[`LinkButton___${style}`], styles[`LinkButton___${state}`], className)}
		download={download}
		target={target}
		ref={ref}
		onClick={onClick}
	>
		{children}
		{icon === 'chevronRight' && (
			<Icon size="sm">
				<ChevronRight />
			</Icon>
		)}
	</a>
);
